module.exports = __webpack_public_path__ + "img/abi-green.625473f4.png";